import {Component, OnInit, ViewChild} from '@angular/core';
import {FormGroup} from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { UserDetail, UserNotificationResponse } from '../../../models/users.model';
import { UserService } from '../../../services/APIs/Users/userservice';
import { DataContextService } from '../../../services/datacontext.service';
import { PreferencesCurrentViewService } from '../../../services/preferences/preferences-current-view';
import { TooltipDirective } from '../../../shared/components/tooltip/tooltip.directive';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {
  form: FormGroup;
  showSearch: boolean = false;
  notifications$: BehaviorSubject<UserNotificationResponse[]> = new BehaviorSubject([]);
  userDetails: UserDetail;
  isActiveView: boolean = true;

  @ViewChild('notificationTooltip') notificationTooltip: TooltipDirective;
  constructor(private userService: UserService, private preferenceCurrentViewService: PreferencesCurrentViewService) {
    // Phase 1 - Commenting user notification calls as user cannot create team requests hence will not get any notification
    // setInterval(_ => this.getUserNotifications(), 3 * 60 * 1000);
    this.userDetails = DataContextService.UserData;
    // DataContextService.getUserNotificationDataEvent().subscribe((res) =>{
    //   if(res) {
    //       this.getUserNotifications();
    //   }
    // })
    this.preferenceCurrentViewService.currentView$.subscribe((res) => {
      this.isActiveView = res.building.length ? true : false;
    })
  }
  ngOnInit(): void {
    // Phase 1 - Commenting user notification calls as user cannot create team requests hence will not get any notification
    // this.getUserNotifications();
  }
  private getUserNotifications() {
    this.userService.getUserNotifications().subscribe((res: UserNotificationResponse[]) => {
      this.notifications$.next(res);
    });
  }
  removeNotification(id: number) {
    this.notificationTooltip.hide();
    // Phase 1 - Commenting user notification calls as user cannot create team requests hence will not get any notification
    // this.userService.removeUserNotification(id).subscribe(_ => this.getUserNotifications());
    setTimeout(() => this.notificationTooltip.show(), 500);
  }
}
